var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M3.543 1.786c0 .272.08.492.179.492.098 0-.035-.24-.035-.512 0-.095.03-.187.065-.266.346-.021.705-.032 1.075-.032 2.666 0 4.827.58 4.827 1.296 0 .716-2.161 1.296-4.827 1.296S0 3.48 0 2.764c0-.417.734-.788 1.874-1.026.174-.723.795-1.441 1.621-1.66.493-.15 2.836-.047 4.267 0 .704.002.671.977-.01.904H4.485c-.358 0-.61.133-.744.303-.135.169-.2.284-.2.501z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#509CF2",
    transform: "translate(2.657 2.04)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1D",
    d: "M13.068 5.277c.75.495 1.433 1.543 1.433 2.504v.96c0 .678-.253 1.676-2.437 2.582-3.021 1.006-6.034 1.008-9.039 0C.931 10.465.527 9.163.513 8.74A30.668 30.668 0 0 1 .5 7.78c0-.912.442-1.716 1.325-2.413.476 2.695 11.702 2.31 11.243-.09z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurling);
export default __webpack_public_path__ + "static/media/curling.04fd9c4b9b0fdb612354a8c16af582be.svg";
export { ForwardRef as ReactComponent };